<template>
  <section class="overview" v-if="ready">
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        My Dashboard&nbsp;
      </h1>
      <overview-card
        class="mt-3"
        :available-workshops="lessonCount"
        :active-students="me.active_students"
        :active-classes="classCount"
      />
      <notifications type="teachers" />
      <lesson-completed />
      <lessons-table />
      <class-quiz-score />
      <v-row>
        <v-col cols="12" md="6">
          <student-invite-not-accepted />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
import Class from '@/modules/class/models/Class'
import Auth from '@/modules/auth/models/Auth'
import LessonCompleted from './overview/LessonCompleted'
import StudentInviteNotAccepted from './overview/StudentInviteNotAccepted'
import LessonsTable from '@/modules/auth/views/dashboard/LessonsTable'
import Notifications from './overview/Notifications'
import { mapState } from 'vuex'
import OverviewCard from '@/modules/auth/views/dashboard/OverviewCard'
import ClassQuizScore from '@/modules/teacher/views/dashboard/overview/ClassQuizScore'

export default {
  name: 'Overview',
  components: {
    LessonCompleted,
    Notifications,
    StudentInviteNotAccepted,
    LessonsTable,
    OverviewCard,
    ClassQuizScore
  },
  data() {
    return {
      ready: false
    }
  },
  computed: {
    schoolInfo() {
      if (!this.me) return ''

      if (this.me.acara_id) {
        return this.me.school_name
      }

      const schoolMetadata = this.me.school_metadata

      if (this.me.role === 'casual') {
        return 'Postcode: ' + schoolMetadata.postcode
      }

      if (
        this.me.role === 'teacher' ||
        this.me.role === 'school_leader_principal'
      ) {
        return schoolMetadata.school_text + ' - ' + schoolMetadata.country
      }

      if (
        this.me.role === 'home_distance' ||
        this.me.role === 'organization_company'
      ) {
        return schoolMetadata.school_text
      }

      if (this.me.role === 'pre_service_teacher') {
        return schoolMetadata.university
      }

      return 'School Info'
    },
    me() {
      return Auth.query()
        .where('type', 'teacher')
        .first()
    },
    lessonCount() {
      return Lesson.query().count()
    },
    classCount() {
      return Class.query().count()
    },
    ...mapState(['bucketUrl'])
  },
  async mounted() {
    this.$store.state.loading = true
    await Class.dispatch('fetchForTeacher')
    await Lesson.dispatch('fetch', this.$route.meta.type)
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  methods: {}
}
</script>

<style lang="scss">
.overview {
}
</style>
